define('services/CustomerGroupService',[
    'app',
    'modules/module',
    'services/EntityCrudService'
], function (app, module) {
    'use strict';
    return module.factory('CustomerGroupService', [
        '$injector',
        CustomerGroupService
    ]);
});


function CustomerGroupService($injector) {

    crudInstance = $injector.instantiate(CrudService);
    crudInstance.setType('CustomerGroup');

    angular.extend(this, crudInstance);

    return this;
};
